import { GetListResult, GetOneResult } from "react-admin";
import HttpClient from "../HttpClient";
import { CustomerResponse } from "../interfaces/Customer/CustomerResponse";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";
import { CallMaskingReferenceModelNameEnum } from "../enums/CallMaskingReferenceModelNameEnum";

export class CustomerService {
    async getAllCustomers(limit: number, offset: number, filter: any): Promise<GetListResult<CustomerResponse>> {
        function processData(data: any) {
            if (/[0-9]/.test(data.fname)) {
                delete data.fname;
            }

            return data;
        }
        filter = processData(filter)
        let filters = ConstructSequelizeFilters(filter, ["fname"], ["mobile", "id"]);
        let data = await HttpClient.get('/centaurus/user/customer', {
            params: {
                filters,
                limit,
                offset
            }
        })
        return {
            data: data.data.data,
            total: data.data.count
        }
    }
    async getCustomerById(id: number): Promise<GetOneResult<CustomerResponse>> {
        let data = await HttpClient.get('/centaurus/user/customer/'+id);
        return data
    }

    async updateCustomerById(payload: any): Promise<GetOneResult<CustomerResponse>> {
        const { id } = payload;
        const allowed = ["fname", "mname", "lname", "address", "email", "gender", "foodPreference"];
        const body: any = {};
        allowed.forEach((key) => {
            if (payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
                body[key] = payload[key];
            }
        });
        const data = await HttpClient.put('/centaurus/user/customer/' + id, body);
        return data;
    }

    async updateCustomerPhone(customerId: number, mobile: string): Promise<GetOneResult<CustomerResponse>> {
        let data = await HttpClient.put(`/centaurus/user/customer/changeNumber/${customerId}`, { mobile });
        return data;
    }
    async getAllTransactionForCustomer(customerId:number,limit:number,offset:number,filters: any = {}, sort: any = {}):Promise<GetOneResult<CustomerResponse>>{
        let data=await HttpClient.get(`/centaurus/user/customer/${customerId}/razorpay-transactions`,
            {
                params:{
                    limit,
                    offset,
                    filters,
                    sort
                }
            }
        )
        return data;
    }
    async getAllHouseForCustomer(customerId: number){
        let data = await HttpClient.get(`/centaurus/user/customer/${customerId}/houses`);
        return data
    }

    async createCustomer(payload: any): Promise<GetOneResult<any>> {
        let data : any  = await HttpClient.post(`/centaurus/user/customer`, payload);
        return data
    }
    async getMaskedCallRecording(customerId: number,referenceModelName:CallMaskingReferenceModelNameEnum): Promise<GetOneResult<any>>{
        let data = await HttpClient.get(`/call-masking/${referenceModelName}/${customerId}/recording`)
        return data
    }
    async updateCustomerExtraDetails(customerId: number, payload: any){
        let data = await HttpClient.patch(`/v2/customer/profile/${customerId}/extra-details`, payload);
        return data?.data;
    }

    async getCustomerCookPrefernces(customerId: number): Promise<GetOneResult<any>> {
        let data = await HttpClient.get(`/centaurus/customer-preferences/customer/${customerId}`);
        return data?.data
    }

    async updateCustomerCookPreferences(customerId: number, payload: any): Promise<GetOneResult<any>> {
        let newpayload = {
            cookRanks: payload,
            customerId
        }
        let data = await HttpClient.patch(`/centaurus/customer-preferences/update-ranks`, newpayload);
        return data?.data
    }

    async getCustomerPrefernceByCustomerId(customerId: number){
        let data = await HttpClient.get(`centaurus/customer-preferences/customer/${customerId}/preferences`);
        return data?.data
    }

    async updateCustomerPrefernceByCustomerId(customerId: number, payload: any): Promise<GetOneResult<any>> {
        let data = await HttpClient.post(`/centaurus/customer-preferences/customer/${customerId}`, payload);
        return data?.data
    }

    async removeFromPrefernce(requestId: number): Promise<GetOneResult<any>> {
        let data = await HttpClient.delete(`/centaurus/customer-preferences/remove/${requestId}`);
        return data?.data
    }

    async getCustomerLogs(limit: number, offset: number, sort: any ,phone: string){
        let data = await HttpClient.get(`/call/user/${phone}`, {
            params: {
                limit,
                offset, 
                sort
            }
        });
        return data;
    }

    async getBlockedCooksByCustomerId(customerId: number): Promise<any[]> {
        let data = await HttpClient.get(`/centaurus/customer-preferences/customer/${customerId}/blocked-cooks`);
        return data?.data ?? [];
    }

    async addToBlacklist(customerId: number, cookIds: string): Promise<GetOneResult<any>> {
        let cookIdsArray = cookIds.split(",").map((id) => id.trim());
        let data = await HttpClient.post(`/centaurus/customer-preferences/blacklist`,{
            customerId,
            cookIds: cookIdsArray
        });
        return data?.data

    }

    async getCustomerCookRatings(customerId: number) {
        const data = await HttpClient.get(`/v1/centaurus/customer-cook-ratings/customer/${customerId}`);
        return data?.data;
    }

    async deleteCustomerCookRating(ratingId: number) {
        const data = await HttpClient.delete(`/v1/centaurus/customer-cook-ratings/${ratingId}`);
        return data?.data;
    }

}
